export const DISMISS_FOREVER_TILL = '2100-01-01T00:00:00Z';

export const isDismissed = (dismissedTill?: string) => {
  if (!dismissedTill) return false;
  const dismissedAt = Date.parse(dismissedTill);
  return Number.isFinite(dismissedAt) && dismissedAt > Date.now();
};
